import Vue from "vue";

export async function runMassiveChange(payload) {
    const response = await Vue.prototype.$http.post(
        "/massive_status_change/execute",
        payload
    );

    return response.data;
}

export async function previewCount(source_status_id) {
    const response = await Vue.prototype.$http.get(
        "/massive_status_change/count",
        {
            params: {
                source_status_id,
            },
        }
    );

    return response.data;
}